if (!customElements.get('sensic-setup-video')) {
  customElements.define('sensic-setup-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      const update = () => {
        button.textContent = video.paused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', video.paused ? 'Play setup video' : 'Pause setup video');
      };
      const play = (withSound = false) => {
        video.muted = !withSound;
        video.play().catch(update);
      };
      // Do not let the general carousel or sound handler hijack native controls.
      video.addEventListener('pointerdown', (event) => event.stopPropagation(), {signal});
      button.addEventListener('click', () => {
        this.manuallyPaused = !video.paused;
        if (video.paused) play(true); else video.pause();
      }, {signal});
      for (const event of ['play', 'pause', 'ended', 'error']) video.addEventListener(event, update, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (this.visible && this.dataset.autoplay === 'true' && !this.manuallyPaused) play();
      }, {signal});
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (!this.visible) video.pause();
        else if (this.dataset.autoplay === 'true' && !this.manuallyPaused && !document.hidden) play();
      }, {threshold: 0.15});
      this.observer.observe(this);
      update();
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
